// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dn-a";
export var fulfillmentFormRail = "_dn-9";
export var headerTitleRow = "_dn-c";
export var orderDetailsWrapper = "_dn-7";
export var orderLinkTrigger = "_dn-2";
export var paymentInformationGrid = "_dn-h";
export var paymentSummaryColumn = "_dn-i";
export var shipmentContainer = "_dn-b";
export var shipmentDetailsMainPane = "_dn-8";
export var shipmentNavigationCard = "_dn-5";
export var shipmentNavigationRail = "_dn-3";
export var shipmentNavigationRailHeader = "_dn-4";
export var shipmentSummaryFact = "_dn-e";
export var shipmentSummaryGrid = "_dn-d";
export var shipmentSummaryMetadataRow = "_dn-f";
export var shipmentSummaryTags = "_dn-g";
export var shipmentWorkspace = "_dn-0";
export var shipmentWorkspaceContent = "_dn-6";
export var shipmentWorkspaceHeader = "_dn-1";